import { render, staticRenderFns } from "./PostsByFormType.vue?vue&type=template&id=5e4bf7e2&scoped=true"
import script from "./PostsByFormType.vue?vue&type=script&lang=js"
export * from "./PostsByFormType.vue?vue&type=script&lang=js"
import style0 from "./PostsByFormType.vue?vue&type=style&index=0&id=5e4bf7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4bf7e2",
  null
  
)

export default component.exports